import { render, staticRenderFns } from "./aFooteren.vue?vue&type=template&id=ff0db19e&scoped=true"
import script from "./aFooteren.vue?vue&type=script&lang=js"
export * from "./aFooteren.vue?vue&type=script&lang=js"
import style0 from "./aFooteren.vue?vue&type=style&index=0&id=ff0db19e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0db19e",
  null
  
)

export default component.exports